/* eslint-disable */
// Company-wide holiday date logic for the loader registry. Fixed dates are
// checked inline (onDay / inRange); computed ones use isNthWeekday; movable /
// lunar holidays use curated PER-YEAR tables — deliberately NOT astronomical
// computation, so they are simple to audit.
//
// TODO(dates): the MOVABLE tables are APPROXIMATE — verify each entry against an
// authoritative source and extend them for each upcoming year before relying on
// them in production.

// True when date d falls on the given 1-indexed month + day.
export function onDay(d, month, day) {
    return d.getMonth() === month - 1 && d.getDate() === day;
}

// True when date d falls within [m1/d1 .. m2/d2] inclusive (same year, 1-indexed).
export function inRange(d, m1, d1, m2, d2) {
    const md = (d.getMonth() + 1) * 100 + d.getDate();
    return md >= m1 * 100 + d1 && md <= m2 * 100 + d2;
}

// True when d is the n-th `weekday` (0=Sun..6=Sat) of `month` (1-indexed).
// e.g. US Thanksgiving = 4th Thursday of November => isNthWeekday(d, 11, 4, 4).
export function isNthWeekday(d, month, weekday, n) {
    if (d.getMonth() !== month - 1 || d.getDay() !== weekday) return false;
    return Math.floor((d.getDate() - 1) / 7) === n - 1;
}

// Movable / lunar holidays — [startMonth, startDay, endMonth, endDay] per Gregorian
// year (1-indexed), 2026–2035. Carnival (Easter − 47) and Chinese New Year are
// astronomically fixed and reliable; Diwali and the two Eids are lunar /
// moon-sighting and are APPROXIMATE (±1 day) — confirm these before each year.
export const MOVABLE = {
    // Brazil Carnival — Carnival Monday + Fat Tuesday.
    carnival: {
        2026: [2, 16, 2, 17], 2027: [2, 8, 2, 9], 2028: [2, 28, 2, 29], 2029: [2, 12, 2, 13], 2030: [3, 4, 3, 5],
        2031: [2, 24, 2, 25], 2032: [2, 9, 2, 10], 2033: [2, 28, 3, 1], 2034: [2, 20, 2, 21], 2035: [2, 5, 2, 6],
    },
    // Diwali (India) — main day (+1); lunar, APPROXIMATE.
    diwali: {
        2026: [11, 8, 11, 9], 2027: [10, 29, 10, 30], 2028: [10, 17, 10, 18], 2029: [11, 5, 11, 6], 2030: [10, 26, 10, 27],
        2031: [11, 14, 11, 15], 2032: [11, 2, 11, 3], 2033: [10, 22, 10, 23], 2034: [11, 10, 11, 11], 2035: [10, 30, 10, 31],
    },
    // Chinese New Year — day 1 + 2.
    cny: {
        2026: [2, 17, 2, 18], 2027: [2, 6, 2, 7], 2028: [1, 26, 1, 27], 2029: [2, 13, 2, 14], 2030: [2, 3, 2, 4],
        2031: [1, 23, 1, 24], 2032: [2, 11, 2, 12], 2033: [1, 31, 2, 1], 2034: [2, 19, 2, 20], 2035: [2, 8, 2, 9],
    },
    // Eid al-Fitr (1 Shawwal) — moon-sighting, APPROXIMATE (±1 day).
    eidFitr: {
        2026: [3, 20, 3, 21], 2027: [3, 10, 3, 11], 2028: [2, 27, 2, 28], 2029: [2, 15, 2, 16], 2030: [2, 5, 2, 6],
        2031: [1, 25, 1, 26], 2032: [1, 15, 1, 16], 2033: [1, 4, 1, 5], 2034: [12, 25, 12, 26], 2035: [12, 14, 12, 15],
    },
    // Eid al-Adha (10 Dhu al-Hijjah) — moon-sighting, APPROXIMATE (±1 day).
    eidAdha: {
        2026: [5, 27, 5, 28], 2027: [5, 17, 5, 18], 2028: [5, 5, 5, 6], 2029: [4, 24, 4, 25], 2030: [4, 14, 4, 15],
        2031: [4, 3, 4, 4], 2032: [3, 22, 3, 23], 2033: [3, 12, 3, 13], 2034: [3, 1, 3, 2], 2035: [2, 18, 2, 19],
    },
};

// True when d falls in the curated range for the given movable-holiday key.
export function isMovable(d, key) {
    const table = MOVABLE[key] && MOVABLE[key][d.getFullYear()];
    return table ? inRange(d, table[0], table[1], table[2], table[3]) : false;
}
